import { useQuery } from '@tanstack/react-query';
import type { UseQueryOptions } from '@tanstack/react-query';
import type { SubscriptionProductChangePlan } from 'v2/interfaces/shopping';
import shoppingSubscriptionService from 'v2/services/shopping/subscription';

function useSubscriptionChangeProducts(
  subscriptionId: number,
  options?: Omit<UseQueryOptions<SubscriptionProductChangePlan[]>, 'queryKey' | 'queryFn'>
) {
  return useQuery({
    queryKey: ['subscription', subscriptionId, 'changeProducts'],
    queryFn: ({ queryKey }) => {
      const [, subscriptionId] = queryKey;
      return shoppingSubscriptionService.getChangePlanProducts(subscriptionId as number).toPromise();
    },
    ...options
  });
}

export { useSubscriptionChangeProducts };
